import React, { useState } from 'react';
import { useContext } from 'react';
import { MovieContext } from '../Context';
import { NavLink } from 'react-router-dom';

const Header = () => {

  const searchURL = 'https://api.themoviedb.org/3/search/movie?api_key=f779d476cdec5963c1d23b8c6fea72dc&query=';
  const { API_URL } = useContext(MovieContext);  
  const [searchTerm, setsearchTerm] = useState('');
  const { movies } = useContext(MovieContext);
  const { getMovies } = useContext(MovieContext); 
  const { movieURL } = useContext(MovieContext);
  const { setMovieURL } = useContext(MovieContext);
  
  const trending = () => {
    setsearchTerm('');
    setMovieURL(API_URL);
    getMovies(API_URL);
    return movies;
  }

  const handleSubmit = (e) => {

    let query = searchURL + searchTerm;
    e.preventDefault();

    if(searchTerm){
      getMovies(query);
      setMovieURL(query);
      setsearchTerm('');
      return movieURL;
    }else{
        getMovies(movieURL);
        setsearchTerm('');
    }

  }  


  return (
    <header>
        <NavLink className='font-bold text-4xl text-black bg-[#F5C518] px-2 rounded-md' to="/projects/mymdb" onClick={trending}>MyMDb</NavLink>
        <form onSubmit={handleSubmit} id='searchform'>
            <input type="text" placeholder="Search..." id="search" onChange={(e) => {setsearchTerm(e.target.value)}} />
        </form>
    </header>
  )
}

export default Header;